var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "div",
        { staticClass: "mb-4" },
        [
          _c(
            "router-link",
            {
              staticClass: "text-primary-link",
              attrs: { to: "/user/listings" }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("message.menu.my_listings")) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c("i", { staticClass: "far fa-chevron-right small" }),
          _vm._v(" " + _vm._s(_vm.title) + "\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c("listing-form")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16a188f5", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16a188f5","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/listing/ManageUserListing.vue
// module id = 1934
// module chunks = 0